import MediaComponent from "./media.component";
import Router from "./media.router";

export const MediaModule = angular
    .module("media", [])
    .component("media", MediaComponent)
    .config(Router);


// WEBPACK FOOTER //
// ./sources/components/media/media.js